// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.interpreter-info[data-v-908628a0] {\n  margin: 5px 0;\n  padding: 16px;\n  border-radius: 4px;\n  background-color: #e6ebee;\n}\n.interpreter-info__response[data-v-908628a0] {\n  margin: 10px 0;\n  color: #b68e56;\n}\n", ""]);
// Exports
module.exports = exports;
